import ApiService from './ApiService';

class CoursePlanApi extends ApiService {

    constructor() {
        super('course-plan');
    }

    createCoursePlan(payload) {
        return this.post('', payload);
    }

    deleteCoursePlan({ id }) {
        return this.delete(id, {});
    }
}

export default CoursePlanApi;